import { Control, Controller } from "react-hook-form";
import { ReactComponent as UploadIcon } from "../../../../assets/svg/icons/upload.svg"

type FileUploadShapefileProps = {
  name: string;
  control: Control;
  onSubmit: (data: any) => void;
}

export function FileUploadShapefile({ name, control, onSubmit }: FileUploadShapefileProps) {

  return <Controller
    name={name}
    control={control}
    render={({ field }) => (

      <div className="uploadFileKMl__container">
        <label htmlFor="inputShapefile">
          <UploadIcon />
          <strong>Upload Shapefile</strong>
        </label>
        <input
          type="file"
          id="inputShapefile"
          onChange={(event) => {
            field.onChange(event);
            onSubmit(event);
          }}
        />
      </div>

    )}
  />
}